import { render, staticRenderFns } from "./OrganizationRegisteredCourses.vue?vue&type=template&id=c9525586&scoped=true&"
import script from "./OrganizationRegisteredCourses.vue?vue&type=script&lang=js&"
export * from "./OrganizationRegisteredCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9525586",
  null
  
)

export default component.exports